import { aboutImages, mangas } from '@/mocks/manga';
import { SITE_NAME } from '@/utils/site';

export default function BrandIntro() {
  const totalViews = mangas.reduce((sum, m) => sum + m.views, 0);

  return (
    <section className="relative overflow-hidden" aria-label="品牌介绍">
      <img
        src={aboutImages.team}
        alt={`${SITE_NAME}品牌介绍横幅`}
        title={`${SITE_NAME}品牌介绍`}
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />

      <div className="relative z-10 mx-auto flex min-h-[420px] w-full max-w-7xl flex-col items-center justify-center px-4 py-20 text-center md:min-h-[480px] md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur md:text-sm">
          <i className="ri-community-line text-secondary-300" aria-hidden="true" />
          关于我们 · About Us
        </span>
        <h1 className="mt-6 max-w-3xl font-heading text-3xl leading-snug text-background-50 md:text-5xl">
          让每一份热爱，都能免费畅读
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          073漫画网诞生于一群漫画发烧友的初心：好漫画不应该被门槛挡住。我们以《健身教练》为起点，专注健身、热血、都市题材，为读者提供免费、流畅、稳定的下拉式漫画阅读体验。
        </p>

        <dl className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-3 md:grid-cols-4">
          {[
            { value: '10+', label: '连载作品' },
            { value: '2,600+', label: '章节内容' },
            { value: `${(totalViews / 10000000).toFixed(1)}千万+`, label: '累计阅读' },
            { value: '98.6%', label: '读者好评率' },
          ].map((item) => (
            <div key={item.label} className="rounded-lg border border-background-50/15 bg-background-50/10 px-3 py-4 backdrop-blur">
              <dd className="font-heading text-xl text-background-50 md:text-2xl">{item.value}</dd>
              <dt className="mt-1 text-xs text-background-50/75">{item.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}